/**
 * tnt-hide-supplier-filters.js
 *
 * Hides internal supplier/logistics tags from Shopify Search & Discovery filter
 * sidebars on collection and search pages. These tags (stox, la cie, atw) are
 * operational data — they must never be visible as customer-facing filter options.
 *
 * This is a theme-side defense that works even if the Search & Discovery app in
 * Shopify Admin is not configured to exclude them. It targets the standard Dawn
 * theme facet structure: input[name="filter.p.tag"] elements whose value matches
 * a blocked tag, hiding the enclosing <li> so the filter option disappears from
 * the sidebar without any layout shift.
 *
 * Also hides the entire filter group (e.g. a "Tag" heading) if hiding its options
 * would leave it completely empty.
 */
(function () {
  var BLOCKED = ['stox', 'la cie', 'atw'];

  function isBlocked(val) {
    if (!val) return false;
    var v = val.toLowerCase().trim();
    for (var i = 0; i < BLOCKED.length; i++) {
      if (v === BLOCKED[i]) return true;
    }
    return false;
  }

  /**
   * Walk all tag filter inputs on the page, hide blocked ones, and hide any
   * filter group that becomes fully empty as a result.
   */
  function hideSupplierFilters() {
    var inputs = document.querySelectorAll('input[name="filter.p.tag"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (!isBlocked(input.value)) continue;

      var li = input.closest('li');
      if (li) li.style.display = 'none';

      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label) {
        var labelLi = label.closest('li');
        if (labelLi) labelLi.style.display = 'none';
      }
    }

    collapseEmptyFilterGroups();
  }

  /**
   * If all <li> items inside a filter-group details/summary block are hidden,
   * hide the whole group header too so there's no dangling empty section.
   */
  function collapseEmptyFilterGroups() {
    var groups = document.querySelectorAll(
      '.facets__disclosure, details[id^="Details-"], details[id^="Filter-"]'
    );
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var listItems = group.querySelectorAll(
        'ul.facets__list > li, ol.facets__list > li'
      );
      if (!listItems.length) continue;
      var allHidden = true;
      for (var j = 0; j < listItems.length; j++) {
        if (listItems[j].style.display !== 'none') {
          allHidden = false;
          break;
        }
      }
      if (allHidden) group.style.display = 'none';
    }
  }

  function run() {
    hideSupplierFilters();

    var observer = new MutationObserver(function () {
      hideSupplierFilters();
    });

    var targets = [
      document.getElementById('main-search-filters'),
      document.getElementById('FacetFiltersForm'),
      document.querySelector('.facets-wrapper'),
      document.querySelector('[id^="main-collection-filters"]'),
    ];

    var observed = false;
    for (var k = 0; k < targets.length; k++) {
      if (targets[k]) {
        observer.observe(targets[k], { childList: true, subtree: true });
        observed = true;
      }
    }

    if (!observed) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
